import { render, staticRenderFns } from "./adminManage.vue?vue&type=template&id=18683144&scoped=true"
import script from "./adminManage.vue?vue&type=script&lang=js"
export * from "./adminManage.vue?vue&type=script&lang=js"
import style0 from "./adminManage.vue?vue&type=style&index=0&id=18683144&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18683144",
  null
  
)

export default component.exports